module.exports = __webpack_public_path__ + "img/basicIndexIcon.7866d588.svg";